import React, {useContext} from "react";
import GoogleMapReact from "google-map-react";
import FiltersContext from "../../restaurantsMap/FiltersContext";
import getCoords from "../../restaurantsMap/helpers/getCoords";
import Pin from "./Pin";

const GMap = () => {
  const {
    data,
    currentFilters,
    currentMapPosition,
    setCurrentMapPosition,
    initMapPosition
  } = useContext(FiltersContext);
  const pins = getCoords(data.countries, currentFilters);
  return (
    <div className="paper paper--boxShadow">
      <div className="inner">
        <div className="map">
          <GoogleMapReact
            bootstrapURLKeys={{key: drupalSettings.amrestologic.gmap_api_key}}
            defaultCenter={initMapPosition.geoCords}
            defaultZoom={initMapPosition.zoom}
            center={currentMapPosition.geoCords}
            zoom={currentMapPosition.zoom}
            options={{ mapId: "d9a8e04b14b617b3" }}
            onChildClick={(item, childProps) =>
              setCurrentMapPosition({
                geoCords: {
                  lat: parseInt(childProps.lat),
                  lng: parseInt(childProps.lng)
                },
                zoom: parseInt(currentMapPosition.zoom)
              })
            }
          >
            {
              pins.map((pin, key) => {
                return (
                  <Pin
                    key={key}
                    lat={pin.geoCords.lat}
                    lng={pin.geoCords.lng}
                    count={pin.count}
                    brands={pin.brands}
                  />
                );
              })
            }
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
};

export default GMap;
